/* eslint-disable no-unused-vars */
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import ElectricityTariffTable from "./ElectricityTariffTable";

export default function ElectricityTariff() {
  const [isLoading, setIsLoading] = useState(false);
  const [eTariff, setETariff] = useState([]);
  const [mode, setMode] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onUpdateTariff = async () => {
    setIsLoading(true);
    try {
      await api.put(endpoint.get_electricity_tariff, {
        data: eTariff,
      });
      await getElectricityTariff();

      Swal.fire({
        title: "Done!",
        text: "Electricity Tariff Updated Successfully",
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      setMode(false);
    } finally {
      setIsLoading(false);
    }
  };
  const getElectricityTariff = async () => {
    setIsLoading(true);
    try {
      let { results, count } = await api.get(endpoint.get_electricity_tariff, {
        params: { limit, page, sortBy: "position", orderBy: "DESC" },
      });

      results = results.map((item, idx) => {
        item.sl = (page - 1) * limit + idx + 1;
        return item;
      });
      setETariff(results);
      setTotal(count || 0);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getElectricityTariff();
  }, [limit, page]);

  useEffect(() => {
    document.title = `${appConfig.name} - Manage Electricity Tariff`;
  }, []);
  return (
    <div className="card p-3 m-md-3">
      {/* <h3>Electricity Tariff</h3> */}
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <label className="az-content-label">Settings</label>
          <span className="d-block py-2">Manage Electricity Tariff</span>
        </div>
      </div>
      <hr className="mt-0" />
      <div className="row mt-4">
        <div className={`col-md-12`}>
          <ElectricityTariffTable
            listLoading={isLoading}
            getElectricityTariff={getElectricityTariff}
            eTariff={eTariff}
            setETariff={setETariff}
            mode={!mode}
          />
          <div className="d-flex justify-content-end mt-5">
            {mode ? (
              <>
                {" "}
                <Button type="primary" className=" me-2" onClick={onUpdateTariff}>
                  Update Tariff
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  className="bg-secondary"
                  onClick={() => {
                    getElectricityTariff();
                    setMode(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                className="me-2"
                type="primary"
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to make changes to the electricity tariff?",
                    //icon: "warning",
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setMode(true);
                    }
                  });
                }}
              >
                Edit Tariff
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
